mobileSize = 800;

$(document).ready(function(){
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 800) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 801) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Down Arrow
  
$(".down-arrow").click(function (){
  $('html, body').animate({
      scrollTop: $(".tier-two").offset().top
  }, 1000);

});

// Footer Social Networks 

$(".socialNetworks").clone().appendTo(".footerItems1");

/// Footer logo replace

$('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + 'images/saffire-logo.png');

/// Footer social logo replace 

$(".footer .socialNetworkIconFacebook img").attr('src', FULLCLIENTTHEMEPATH + 'images/facebook-icon.png');
$(".footer .socialNetworkIconInstagram img").attr('src', FULLCLIENTTHEMEPATH + 'images/instagram-icon.png');
$('.footer .socialNetworkLink img[alt="Google Photos"]').attr('src', FULLCLIENTTHEMEPATH + 'images/google-photos-icon.png');
});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');
});